/** @jsx jsx */
import { jsx, Container, Heading, Grid, Box, Image } from 'theme-ui'
import { FC } from 'react'
import { space } from '~/gatsby-plugin-theme-ui'
import { ButtonRugs } from '~/components/button-rug-collections'
import { Link } from 'gatsby'
import contemporaryRugCategories from '../../../static/media/contemporary-rug-categories.jpg'
import MobileCollectionCarousel from './mobile-collections-carousel'
import HeadingV2 from '~/componentsV2/heading'
import { FeaturedCollectionInterface } from './types'

interface Props {
  title: string
  handle?: string
  description?: string
  featuredCollectionsList?: FeaturedCollectionInterface[]
}

const CollectionLinks: FC<Props> = ({ title, featuredCollectionsList = [], handle }) => {
  const toReplace = '| BEN SOLEIMANI'
  const _title = title.toLowerCase().replace(toReplace, '-')
  return (
    <Container
      sx={{
        marginTop: '40px',
      }}
      className="collection-links"
    >
      <Box
        sx={{
          display: ['block', 'block', 'none', null],
        }}
        className="mobile-collection-links"
      >
        <HeadingV2
          sx={{
            textAlign: 'center',
            mt: [space.md3],
            mb: [space.md3],
            color: 'text',
            fontSize: '32px !important',
          }}
        >
          {handle === 'textiles' ? _title : null}
        </HeadingV2>
        <MobileCollectionCarousel featuredCollectionsList={featuredCollectionsList} />
        <HeadingV2
          sx={{
            mt: [space.md3],
            mb: [space.md3],
            color: 'text',
            display: handle === 'textiles' ? 'none' : 'block',
            fontSize: '32px !important',
          }}
        >
          {handle === 'rugs' ? (
            <Box>
              SHOP <em>All</em> RUGS
            </Box>
          ) : (
            _title
          )}
        </HeadingV2>
      </Box>
      <Box
        sx={{
          display: ['none', 'none', 'block'],
        }}
      >
        <Grid columns={[null, null, 3, featuredCollectionsList.length]} gap={35}>
          {featuredCollectionsList.length > 0 &&
            featuredCollectionsList?.map((item, key) => {
              return (
                <Box key={key}>
                  <Link
                    to={`/collections/${item.node.handle}`}
                    sx={{
                      '&:hover': {
                        '#collection-link': {
                          display: 'flex !important',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#777777',
                          opacity: 0.35,
                        },
                      },
                    }}
                  >
                    <Box sx={{ position: 'relative' }}>
                      <Box
                        sx={{
                          height: '100%',
                          '> div': {
                            height: '100%',
                          },
                          img: {
                            width: '100%',
                            height: '100%',
                          },
                        }}
                      >
                        <Image
                          src={
                            item.node.metafields.collectionCustomImageUrl === null
                              ? contemporaryRugCategories
                              : item.node.metafields.collectionCustomImageUrl
                          }
                          alt={item.node.title || 'Collection Image'}
                        />
                      </Box>
                      <div
                        id="collection-link"
                        style={{
                          display: 'none',
                          color: 'white',
                          position: 'absolute',
                          top: '0',
                          bottom: '2px',
                          left: '0',
                          right: '0',
                        }}
                      ></div>
                    </Box>
                    <Box
                      sx={{
                        mt: space.sm,
                      }}
                    >
                      <ButtonRugs
                        label={item.node.title}
                        type="button"
                        hasArrow={false}
                        to={`/collections/${item.node.url}`}
                        handle={handle}
                        sx={{
                          width: '175px !important',
                          height: '20px !important',
                          minHeight: 10,
                          fontSize: '12px',
                          minWidth: '150px !important',
                          color: '#595858',
                          backgroundColor: 'transparent',
                          borderStyle: 'none',
                          textAlign: 'left',
                          padding: 0,
                          textTransform: 'uppercase',
                        }}
                      />
                    </Box>
                  </Link>
                </Box>
              )
            })}
        </Grid>
        <HeadingV2
          sx={{
            fontSize: '32px !important',
            textAlign: 'initial',
            mt: [space.md3],
            fontWeight: 400,
            color: 'text',
            textTransform: 'uppercase',
            mb: 0,
          }}
        >
          {handle === 'rugs' ? 'ALL RUGS' : title}
        </HeadingV2>
      </Box>
    </Container>
  ) as JSX.Element
}

export default CollectionLinks
